// Tokens de mouvement — port web du module Reanimated.
//
// Règle inchangée : plus AUCUNE durée littérale dans le code d'animation, on
// pioche ici. Les valeurs sont reprises telles quelles :
//   fast  → sorties, replis (un départ n'a pas besoin d'être admiré)
//   base  → micro-interactions et entrées standard (toast, steps, chips)
//   slow  → surfaces entrantes plus lourdes (cartes d'écran, reveals)
//   pulse → respiration des indicateurs vivants (halo SOS, live dots)
//
// Ce qui change : les easings de Reanimated (`Easing.out(Easing.cubic)`)
// deviennent des courbes de Bézier CSS, mathématiquement équivalentes.
// `ReduceMotion.System` n'a pas d'équivalent déclaratif — sur web, le respect
// du réglage « réduire les animations » passe par la media query
// `prefers-reduced-motion`, appliquée globalement dans index.css. C'est donc
// couvert, mais à un autre endroit : ne rien ajouter par composant.
//
// La remarque sur l'import direct (ne pas passer par le barrel) tombe : ce
// module ne tire plus aucune dépendance. Il reste hors du barrel par symétrie
// avec la version native, pour ne pas casser les imports lors du portage.

export const motion = {
  duration: {
    fast: 120,
    base: 220,
    slow: 350,
    pulse: 900,
  },

  /** Mêmes durées, en chaîne CSS — pour `transitionDuration` / `animation`. */
  durationCss: {
    fast: "120ms",
    base: "220ms",
    slow: "350ms",
    pulse: "900ms",
  },

  // Convention Base : on SORT plus vite qu'on entre, et l'entrée décélère
  // (out) quand la sortie accélère (in).
  // cubic-bezier équivalents de Easing.out(Easing.cubic) / Easing.in(Easing.cubic).
  easing: {
    enter: "cubic-bezier(0.33, 1, 0.68, 1)", // easeOutCubic
    exit: "cubic-bezier(0.32, 0, 0.67, 0)", // easeInCubic
  },
} as const;

/** Raccourci pour une transition CSS complète : `transition: transitionIn("opacity")`. */
export function transitionIn(property: string, speed: keyof typeof motion.durationCss = "base") {
  return `${property} ${motion.durationCss[speed]} ${motion.easing.enter}`;
}

export function transitionOut(property: string, speed: keyof typeof motion.durationCss = "fast") {
  return `${property} ${motion.durationCss[speed]} ${motion.easing.exit}`;
}
